import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import formatDate from '@/services/general/formatIsoDate';

export default function transformer(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 0;
    serverTableData.orderBy = 'CreationTime';
  }
  if (serverTableData.query && serverTableData.query.actif === undefined) {
    serverTableData.query.actif = true;
  }
  if (serverTableData.orderBy === 'type') {
    serverTableData.orderBy = 'SupportCommercial.CategorieVente';
  }
  if (serverTableData.orderBy === 'format') {
    serverTableData.orderBy = 'produitReseauNumerique.formatId';
  }
  if (serverTableData.orderBy === 'typeReseau') {
    serverTableData.orderBy = 'produitReseauNumerique.typeReseauId';
  }
  if (serverTableData.orderBy === 'produitReseauNumerique.adresse.ville') {
    serverTableData.orderBy = 'Ville';
  }
  if (serverTableData.query?.dureeAffectation) {
    serverTableData.query.dureeAffectation.dateDebut = formatDate(
      serverTableData.query.dureeAffectation.dateDebut,
    );
    serverTableData.query.dureeAffectation.dateFin = formatDate(
      serverTableData.query.dureeAffectation.dateFin,
    );
  }
  if (serverTableData.query?.dateVisualisation) {
    serverTableData.query.dateVisualisation = formatDate(serverTableData.query.dateVisualisation);
  }
  return generalTransformer(serverTableData);
}
